import {Action} from '../../common/types/common';
import {AnyAction} from 'redux';

/* tslint:disable:ter-indent */
export const ERROR_GENERAL_ACTION : Action = {
    name: 'ERROR_GENERAL_ACTION',
    action: (apiError: any, retryAction: AnyAction = null, url = '', body = {}, method = '',
             unexpectedErrors = []) => ({
        apiError,
        retryAction,
        url,
        method,
        body,
        unexpectedErrors,
        type: ERROR_GENERAL_ACTION.name
    })
};

export const IS_LOADING_ACTION : Action = {
    name: 'IS_LOADING_ACTION',
    action: (payload: any) => ({
        payload,
        type: IS_LOADING_ACTION.name
    })
};

export const IS_LOADED_ACTION : Action = {
    name: 'IS_LOADED_ACTION',
    action: (payload: any) => ({
        payload,
        type: IS_LOADED_ACTION.name
    })
};

export const IS_LOADED_SUCCESS_ACTION : Action = {
    name: 'IS_LOADED_SUCCESS_ACTION',
    action: (payload: any) => ({
        payload,
        type: IS_LOADED_SUCCESS_ACTION.name
    })
};

export const INIT_APP_ACTION : Action = {
    name: 'INIT_APP_ACTION',
    action: (country: string) => ({
        country,
        type: INIT_APP_ACTION.name
    })
};

export const CLEAN_STATE_ACTION : Action = {
    name: 'CLEAN_STATE_ACTION',
    action: () => ({
        type: CLEAN_STATE_ACTION.name
    })
};